import React, { useState, useEffect, useRef } from 'react'
import { SendSampleEquipmentBreadCrumbData } from '@/constants/breadcrumb'
import { Row, Col, Form, message, Button } from 'antd'
import Headers from '@/components/Headers'
import { fetchList, add, edit } from '@/api/equipment'
import Search from './Search'
import Content from './Content'
import Modal from './Modal'
import UpdateModal from './UpdateModal'

const SendSampleEquipment = (props) => {
  const [dataSource, setDataSource] = useState([])

  const [otherParams, setOtherParams] = useState({})

  const [visible, setVisible] = useState(false)

  const [updateVisible, setUpdateVisible] = useState(false)

  const [current, setCurrent] = useState({})

  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  })

  const containerRef = useRef(null)

  const handleCancel = () => {
    setVisible(false)
  }

  const fetch = () => {
    fetchList({
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      ...otherParams,
    }).then((res) => {
      if (res.success) {
        setDataSource(res.data.list)
        setPage({ ...page, total: res.data.total })
      }
    })
  }

  useEffect(() => {
    fetch()
  }, [page.pageSize, page.pageNum, otherParams])

  const handleTableChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum, pageSize })
  }

  const handleShowSizeChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum: 1, pageSize })
  }

  const handleEdit = (record) => {
    setCurrent(record)
    setVisible(true)
  }

  //新增运营商
  const handleAdd = () => {
    setVisible(true)
    setCurrent({})
  }

  const handleConfirm = (type) => (values) => {
    if (type === 'add') {
      add(values).then((res) => {
        if (res.success) {
          setVisible(false)
          message.success('添加设备成功!')
          fetch()
        }
      })
    } else {
      edit(values).then((res) => {
        if (res.success) {
          setVisible(false)
          message.success('编辑设备成功!')
          fetch()
        }
      })
    }
  }

  const handleSearch = (values) => {
    setOtherParams({ ...values })
    setPage({ ...page, pageNum: 1 })
  }

  const handleRefresh = () => {
    setUpdateVisible(false)
    setVisible(false)
    setSelectedRowKeys([])
    setCurrent({})
    fetch()
  }

  const handleUpdate = (record) => {
    setUpdateVisible(true)
    setCurrent(record)
  }

  const handleBatchUpdate = () => {
    dataSource.forEach((item) => {
      if (item.capsuleId == selectedRowKeys[0]) {
        const { enableHardwareVersion, enableVersionName } = item
        setCurrent({
          enableVersionName,
          enableHardwareVersion,
        })
      }
    })
    setUpdateVisible(true)
  }

  return (
    <div className='container' ref={containerRef}>
      <Headers BreadCrumbData={SendSampleEquipmentBreadCrumbData}></Headers>

      <Search
        onAdd={handleAdd}
        onSearch={handleSearch}
        selectedRowKeys={selectedRowKeys}
        onUpdate={handleBatchUpdate}
      />

      <Modal
        visible={visible}
        current={current}
        getContainer={() =>
          containerRef ? containerRef.current : document.body
        }
        onCancel={handleCancel}
        onAdd={handleConfirm('add')}
        onEdit={handleConfirm('edit')}
      />

      <UpdateModal
        visible={updateVisible}
        current={current}
        onCancel={() => {
          setUpdateVisible(false)
          setCurrent({})
        }}
        onRefresh={handleRefresh}
        selectedRowKeys={selectedRowKeys}
        // getContainer={() =>
        //   containerRef ? containerRef.current : document.body
        // }
      />

      <Content
        dataSource={dataSource}
        page={page}
        onTableChange={handleTableChange}
        onShowSizeChange={handleShowSizeChange}
        onEdit={handleEdit}
        onRefresh={handleRefresh}
        onUpdate={handleUpdate}
        selectedRowKeys={selectedRowKeys}
        onChangeSelectedRowKeys={(selectedRowKeys) =>
          setSelectedRowKeys(selectedRowKeys)
        }
      />
    </div>
  )
}

export default Form.create()(SendSampleEquipment)
